<template lang="pug">
.task-item(
  v-if="!hidden"
  :class="{ 'task-item-surprised': task.isHighlight }"
  @click="handleClick"
)
  .task-left
    .left
      .icon-new-block
        SafeImg(class-name="left-logo" :src="taskData && taskData.iconUrl")
    .mid
      .title {{ taskData.title }}
      .progress
        .progress-right(v-if="taskData && taskData.amount")
          img.progress-right-img(:src="coinIcon")
          .progress-right-text +{{ taskData.amount }}
        .progress-left {{ taskData && taskData.desc }}
  .right
    .btn.doing {{ taskData && taskData.btnName }}
</template>

<script>
import SafeImg from '@/components/safe-img';
import eventBus from '@/const/eventBus';
import { ParamsUtil } from '@/utils/params';
import { handleTaskBtnClick, getGdtSessionId } from '../../common/task';
import { loadPlatformAds } from '../../common/bridge';
import SPM from '../../common/spm';

export default {
  name: 'GdtTaskCard',
  components: {
    SafeImg,
  },
  props: {
    task: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      default: -1,
    },
    isSurpriseTask: {
      type: Boolean,
      default: false,
    },
    doubleInformation: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: {
    isSupportAd: { default: () => () => false },
  },

  data() {
    return {
      adInfo: {},
      taskData: {},
      pageId: '',
      hidden: true,
      doubleInformationHistory: null,
    };
  },

  computed: {
    coinIcon() {
      return 'https://m.hellobike.com/fd018348_new_coin.png';
    },
    spmBusinessInfo() {
      const {
        title, taskCode, status, amount,
      } = this.taskData;
      return {
        task_name: title || '',
        task_id: taskCode || '',
        isSurpriseTask: this.isSurpriseTask ? '1' : '0',
        buttonState: status != null ? String(status) : '',
        rankNum: this.index + 1,
        taskBonus: amount || '',
      };
    },
  },

  watch: {
    doubleInformation: {
      handler(newVal) {
        this.doubleInformationHistory = { ...newVal };
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.preload();
    eventBus.$on('taskListRefreshed', this.preload);
  },

  beforeDestroy() {
    eventBus.$off('taskListRefreshed', this.preload);
  },

  methods: {
    buildTaskData(adInfo, pageId) {
      return {
        ...this.task,
        title: adInfo.title,
        iconUrl: adInfo.iconUrl,
        desc: adInfo.desc,
        pageId,
      };
    },

    async preload() {
      const {
        additionalDescSuffix,
        taskCode,
        amount,
        ylhTaskAction,
      } = this.task;
      const loadRes = await loadPlatformAds({
        pageName: 'gdtTask',
        timeout: '2',
        scene: 'rebateBonus',
        adsource: ParamsUtil.getParams().adsource || '',
        adsInfo: {
          adUnitId: additionalDescSuffix,
          taskCode,
          rewardCount: amount,
        },
        sessionId: getGdtSessionId(),
        otherInfo: {},
      });
      const { code, pageId, adInfo } = loadRes || {};
      if (code === 0 && pageId && adInfo) {
        const { taskAction } = adInfo;
        // 媒体数据与任务匹配即展示
        const isMatched = (ylhTaskAction || []).includes(taskAction);

        if (!isMatched) {
          this.hidden = true;
          this.$emit('gdt-change', true);
          return;
        }
        this.pageId = pageId;
        this.adInfo = adInfo;
        this.taskData = this.buildTaskData(adInfo, pageId);
        this.hidden = false;
        this.$emit('gdt-change', false);
        // 优量汇广告任务曝光埋点
        SPM.moduleExpose({
          moduleId: 'platform_superadver_task',
          contentId: 'platform_superadver_task',
          exposureTimes: 1,
          businessInfo: this.spmBusinessInfo,
        });
      } else {
        this.hidden = true;
        this.$emit('gdt-change', true);
      }
    },

    async handleClick() {
      // 优量汇广告任务点击埋点
      SPM.clickButton({
        buttonName: 'platform_superadver_task',
        businessInfo: this.spmBusinessInfo,
      });
      const options = {
        scene: 'task_list',
        needReceiveCoupon: false,
        doubleInformationHistory: this.doubleInformationHistory,
        supportAd: this.isSupportAd(),
        taskIndex: this.index,
        isSurpriseTask: this.isSurpriseTask,
      };
      await handleTaskBtnClick.call(this, this.taskData, options);
      this.doubleInformationHistory = null;
    },
  },
};
</script>

<style lang="less" scoped>
.task-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 100%;
  align-items: center;
  position: relative;
  padding: 0.12rem;

  &.task-item-surprised {
    background: linear-gradient(93.77deg, #fff3b3 0%, #fffdf5 32.24%, #fff 53.49%);
  }

  .task-left {
    display: flex;

    .left {
      margin-right: 0.1rem;

      .icon-new-block {
        overflow: hidden;
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 0.12rem;
      }
    }
  }

  .mid {
    display: flex;
    flex-direction: column;
    flex: 1;
    max-width: 1.9rem;
    overflow: hidden;
    align-items: flex-start;

    .title {
      max-width: 1.9rem;
      font-size: 0.14rem;
      line-height: 0.2rem;
      font-weight: 500;
      color: #242729;
      margin-bottom: 0.02rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .progress {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;

      .progress-left {
        flex: 1;
        min-width: 0;
        color: rgba(90, 96, 102, 0.8);
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .progress-right {
        display: flex;
        align-items: center;
        height: 0.16rem;
        padding-right: 0.08rem;
        border-radius: 0.16rem;
      }

      .progress-right-img {
        width: 0.16rem;
        height: 0.16rem;
      }

      .progress-right-text {
        color: #fe852a;
        font-weight: 600;
        font-size: 0.12rem;
        margin-left: 0.02rem;
      }
    }
  }

  .right {
    flex-direction: column;
    align-items: flex-end;
    position: relative;

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 0.62rem;
      height: 0.28rem;
      line-height: normal;
      font-size: 0.12rem;
      font-weight: 500;
      border-radius: 0.32rem;

      &.doing {
        background-color: #fff;
        color: #fb750f;
        border: 0.01rem solid #ff8000;
      }
    }
  }
}
</style>
